import { render, staticRenderFns } from "./pattern-payment.vue?vue&type=template&id=3ff839fe&scoped=true&"
import script from "./pattern-payment.vue?vue&type=script&lang=ts&"
export * from "./pattern-payment.vue?vue&type=script&lang=ts&"
import style0 from "./pattern-payment.vue?vue&type=style&index=0&id=3ff839fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff839fe",
  null
  
)

export default component.exports